import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/common/jwt.service";
import i18n from "@/common/lang.serivce";
import store from "@/store";
import router from "@/router";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import {
  LOGOUT,
  SHOW_SNACKBAR,
  FETCH_CURRENT_USER,
  VALIDATION,
  RESET_VALIDATION
} from "@/store/actions.type";
import { SET_AUTH } from "@/store/mutations.type";
import qs from "qs";
import _ from "lodash";
import { FETCH_DICTIONARY } from "../store/actions.type";

const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL;
    Vue.axios.defaults.headers.common["Content-Type"] = "application/json";

    this.addInterceptors();

    if (JwtService.getToken()) {
      store.commit(SET_AUTH, JwtService.getToken());
    }
  },

  setHeader() {
    Vue.axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${JwtService.getToken()}`;

    store.dispatch(FETCH_CURRENT_USER);
    store.dispatch(FETCH_DICTIONARY);
  },

  addInterceptors() {
    Vue.axios.interceptors.response.use(
      response => {
        return response;
      },
      error => {
        if (error.response.status === 400) {
          store.dispatch(VALIDATION, error.response.data.errors);

          return Promise.reject(error);
        }
        if (
          error.response.status === 401 &&
          router.history.current.name !== "Login"
        ) {
          store.dispatch(LOGOUT);
          router.push({ name: "Login" });
        }

        store.dispatch(SHOW_SNACKBAR, {
          text: i18n.t(
            error.response.data.message || error.response.data.error
          ),
          color: "error",
          autoclose: false
        });

        return Promise.reject(error);
      }
    );

    Vue.axios.interceptors.request.use(config => {
      store.dispatch(RESET_VALIDATION);
      NProgress.start();
      return config;
    });

    Vue.axios.interceptors.response.use(
      response => {
        NProgress.done();
        return response;
      },
      error => {
        NProgress.done();
        return Promise.reject(error.response);
      }
    );
  },

  filteredCollection(resource, params, search, filters) {
    filters = _.pickBy(filters, _.identity);

    return Vue.axios
      .get(resource, {
        params: {
          page: params.page,
          limit: params.rowsPerPage,
          sort: params.sortBy,
          order: params.descending ? "DESC" : "ASC",
          search: search,
          filter: filters
        },
        paramsSerializer: function(params) {
          return qs.stringify(params, { arrayFormat: "repeat" });
        }
      })
      .catch(error => {
        throw new Error(`[RWV] ApiService ${error}`);
      });
  },

  query(resource, params) {
    return Vue.axios.get(resource, params).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },

  get(resource, id) {
    let url = resource;
    if (typeof id !== "undefined") {
      url += `/${id}`;
    }
    return Vue.axios.get(url).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },

  post(resource, params) {
    return Vue.axios.post(`${resource}`, params);
  },

  update(resource, slug, params) {
    return Vue.axios.put(`${resource}/${slug}`, params);
  },

  put(resource, params) {
    return Vue.axios.put(`${resource}`, params);
  },

  delete(resource, id) {
    let url = resource;
    if (typeof id !== "undefined") {
      url += `/${id}`;
    }

    return Vue.axios.delete(url);
  },

  uploadFile(resource, file, uploadProgress) {
    let formData = new FormData();
    formData.append("file", file);

    return Vue.axios.post(`${resource}`, formData, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      onUploadProgress: uploadProgress
    });
  }
};

export default ApiService;
